import React, { useState } from 'react';

/**
 * <ConfirmDialog> - generischer Bestaetigungsdialog fuer destruktive/sensible
 * Deployment-Aktionen (revoke, approve, status, reset-instance, follow-up).
 *
 * Props:
 *   title, message   - Texte (vom Aufrufer uebersetzt).
 *   confirmLabel     - Label des Bestaetigungs-Buttons.
 *   danger           - true faerbt den Bestaetigungs-Button rot.
 *   busy             - true -> Buttons disabled + Spinner-Text.
 *   onConfirm        - async () => void; Dialog bleibt offen bis Promise resolved.
 *   onCancel         - () => void.
 *   children         - optionale zusaetzliche Felder (z.B. Datums-Input).
 */
export default function ConfirmDialog({
  title, message, confirmLabel, cancelLabel = 'Abbrechen',
  danger = false, busy = false, onConfirm, onCancel, children,
}) {
  const [working, setWorking] = useState(false);
  const isBusy = busy || working;

  const handleConfirm = async () => {
    setWorking(true);
    try {
      await onConfirm();
    } finally {
      setWorking(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9100,
      }}
      onClick={isBusy ? undefined : onCancel}
    >
      <div
        style={{
          background: 'var(--bg-card)', border: '1px solid var(--border)',
          borderRadius: 12, width: '90%', maxWidth: 460, padding: 26,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>{title}</div>
        {message && (
          <div style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.6, marginBottom: 16 }}>
            {message}
          </div>
        )}
        {children}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 18 }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={isBusy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? 'btn btn-danger' : 'btn btn-primary'}
            onClick={handleConfirm}
            disabled={isBusy}
          >
            {isBusy ? '...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
